import React from "react";
import { Navigate, useParams, Link } from "react-router-dom";
import pmsConfigs from "../utils/pmsConfigs";
import LandingFridge from "../icons/desktopFridge.png";

const PMSLandingPage = () => {
  const { pmsName } = useParams();
  const config = pmsConfigs[pmsName?.toLowerCase()];

  if (!pmsName || !config) {
    return <Navigate to="/signup" />;
  }

  return (
    <div className="w-full bg-[#fefaf6] text-gray-900">
      {/* HERO */}
      <section className="w-full bg-[#fefaf6] px-4 laptop:px-0 pt-24 pb-10">
        <div className="max-w-[1200px] mx-auto flex flex-col laptop:flex-row items-center justify-between gap-10">
          {/* LEFT (text + button) */}
          <div className="flex-1">
            <h1 className="text-[32px] laptop:text-[40px] font-serif font-medium leading-snug tracking-tight">
              Enhance Your {config.name} Properties<br />
              with Effortless, 5-Star Grocery Stocking
            </h1>
            <p className="mt-3 text-[15px] laptop:text-[17px] text-gray-700 leading-relaxed">
              Bellhopt is a luxury pre-arrival grocery delivery, stocking, and online ordering platform fully integrated with {config.name}. 
              It’s completely free for hosts, requires no onboarding fees, and you earn a <strong>5% commission on every order</strong>.
              Our highly trained concierge staff unpacks and stages each delivery for a flawless 5-star guest welcome.
            </p>
            <div className="mt-6 flex justify-center laptop:justify-start">
  <Link to="/signup">
    <button className="bg-black text-white px-6 py-3 rounded-full text-sm laptop:text-base font-semibold shadow-md hover:shadow-lg transition-all">
      Activate Bellhopt for Free
    </button>
  </Link>
</div>

          </div>

          {/* RIGHT (fridge image) */}
          <div className="flex-1 flex justify-end">
            <img
              src={LandingFridge}
              alt="Luxury stocked fridge"
              className="w-full max-w-[320px] laptop:max-w-[380px] rounded-2xl shadow-lg object-cover"
            />
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="bg-[#fefaf6] py-12 px-6">
        <div className="max-w-6xl mx-auto text-center">
          <h2 className="text-[34px] font-serif font-medium mb-14">How It Works</h2>
          <div className="grid laptop:grid-cols-3 gap-12 text-left">
            <div>
              <h3 className="text-md font-semibold mb-1">1. Seamless Integration</h3>
              <p className="text-[15px] text-gray-700 leading-relaxed">
                Bellhopt syncs with your {config.name} listings, pulling check-in times, cleaning schedules, and entry instructions—fully automated and zero effort for you.
              </p>
            </div>
            <div>
              <h3 className="text-md font-semibold mb-1">2. Guests Shop Instantly</h3>
              <p className="text-[15px] text-gray-700 leading-relaxed">
                We send each guest a personalized shopping link—no app download or account creation required. Guests simply shop and check out.
              </p>
            </div>
            <div>
              <h3 className="text-md font-semibold mb-1">3. We Deliver & Stock—You Earn</h3>
              <p className="text-[15px] text-gray-700 leading-relaxed">
                Our vetted concierge staff unpacks and stages items with care. You earn commission on every order, with no involvement needed.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="bg-[#fefaf6] py-20 px-6 text-center">
        <div className="max-w-2xl mx-auto">
          <h2 className="text-[30px] font-serif font-medium mb-5">
            Ready to Offer Bellhopt to Your Guests?
          </h2>
          <p className="text-[16px] text-gray-600 mb-8 leading-relaxed">
            Deliver a luxury grocery experience, increase guest satisfaction, and earn commission—at no cost to you.
          </p>
          <Link to="/signup">
            <button className="bg-black text-white px-8 py-3 rounded-full text-base font-semibold shadow hover:opacity-90 transition">
              Get Started Now
            </button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default PMSLandingPage;
